import { render, staticRenderFns } from "./descargar_certificado.vue?vue&type=template&id=18c12e34"
import script from "./descargar_certificado.vue?vue&type=script&lang=js"
export * from "./descargar_certificado.vue?vue&type=script&lang=js"
import style0 from "./descargar_certificado.vue?vue&type=style&index=0&id=18c12e34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports